import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import { Alert, Button, Grid, MenuItem, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { OssSectionPanel } from "../common/OssPanel";

const targetKeys = [
  ["schedule.day_basis", "일정 계산 기준", "STRING"],
  ["schedule.default_lead_days", "기본 생산 소요일", "NUMBER"],
  ["schedule.default_buffer_days", "계획확정 여유일", "NUMBER"],
  ["risk.attention_margin_days", "주의 여유일", "NUMBER"],
  ["risk.high_margin_days", "고위험 여유일", "NUMBER"],
  ["risk.overdue_margin_days", "초과 기준일", "NUMBER"],
];

export const OssSettingsEditor = ({ settings = [], loading, onSave }) => {
  const initialValues = useMemo(
    () =>
      targetKeys.reduce((acc, [key]) => {
        const row = settings.find((item) => item.setting_key === key);
        acc[key] = row?.setting_value || "";
        return acc;
      }, {}),
    [settings]
  );
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    setValues(initialValues);
  }, [initialValues]);

  const submit = () => {
    onSave(
      targetKeys.map(([settingKey, label, valueType]) => ({
        settingKey,
        settingValue: values[settingKey],
        valueType,
        description: label,
      }))
    );
  };

  return (
    <OssSectionPanel
      title="운영 기준"
      sx={{ minHeight: 280 }}
    >
      <Grid container spacing={1.5}>
        {targetKeys.map(([key, label]) => (
          <Grid item xs={12} md={key === "schedule.day_basis" ? 12 : 6} key={key}>
            <TextField
              select={key === "schedule.day_basis"}
              fullWidth
              size="small"
              label={label}
              value={values[key] || ""}
              onChange={(event) => setValues((prev) => ({ ...prev, [key]: event.target.value }))}
            >
              {key === "schedule.day_basis" && [
                <MenuItem key="BUSINESS" value="BUSINESS">영업일 기준</MenuItem>,
                <MenuItem key="CALENDAR" value="CALENDAR">달력일 기준</MenuItem>,
              ]}
            </TextField>
          </Grid>
        ))}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", pt: 0.5 }}>
          <Button variant="contained" startIcon={<SaveRoundedIcon />} disabled={loading} onClick={submit}>
            기준 저장
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Alert
            severity="info"
            icon={false}
            sx={{
              mt: 0.5,
              py: 1,
              px: 1.25,
              borderRadius: "8px",
              bgcolor: "#eef6ff",
              color: "#475569",
              "& .MuiAlert-message": { py: 0, fontSize: 12.5, lineHeight: 1.5 },
            }}
          >
            기준 저장은 새 주문과 이후 수정되는 주문에 적용됩니다. 기존 주문까지 반영하려면 상단의 전체 주문 재계산을 실행하세요.
          </Alert>
        </Grid>
      </Grid>
    </OssSectionPanel>
  );
};
